"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconListItem = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_icon_1 = require("@travelnest/merlin.icon");
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const IconListItemWrapper = styled_1.default.div `
	display: flex;
	align-items: start;

	.icon-list-item_icon {
		display: inline-block;
		border-radius: 50%;
		text-align: center;
		vertical-align: middle;
		flex-shrink: 0;
		width: 1.25rem;
		height: 1.25rem;
	}

	.icon-list-item_icon-success {
		background-color: ${merlin_theme_1.default.colours.success.primary};
	}

	.icon-list-item_icon-error {
		background-color: ${merlin_theme_1.default.colours.error.primary};
	}

	.icon-list-item_icon-tip {
		background-color: ${merlin_theme_1.default.colours.tip.default};
	}

	.icon-list-item_icon-primary {
		background-color: ${merlin_theme_1.default.colours.primary.primary};
	}

	.icon-list-item_children-wrapper {
		padding-left: ${merlin_theme_1.default.layout.spacing.standard};
		margin-top: 0;

		& > :first-of-type {
			margin-top: 0;
		}

		& > p {
			font-size: ${merlin_theme_1.default.typography.b1.fontSize};
			font-weight: ${merlin_theme_1.default.typography.b1.fontWeight};
			line-height: ${merlin_theme_1.default.typography.b1.lineHeight};
		}
	}
`;
const IconListItem = (props) => {
    const { icon } = props;
    const display = !!props.display ? props.display : 'default';
    const iconColour = display === 'default' ? 'black' : 'white';
    const iconClasses = ['icon-list-item_icon', `icon-list-item_icon-${display}`, `icon-list-item_icon-large`].join(' ');
    return React.createElement(IconListItemWrapper, null,
        React.createElement("span", { className: iconClasses },
            React.createElement(merlin_icon_1.Icon, { icon: icon, colour: iconColour })),
        React.createElement("div", { className: 'icon-list-item_children-wrapper' }, props.children));
};
exports.IconListItem = IconListItem;
//# sourceMappingURL=IconListItem.js.map